<template>
  <v-container>
    <v-btn
      color="#4d48f9"
      style="text-transform: none !important; color: white;"
      @click="routeReaderAppUserAdd()"
    >
      YENİ KULLANICI EKLE
    </v-btn>
    <br />
    <br />
    <v-card>
      <v-card-title>
        MerchantApp Kullanıcıları
        <v-spacer></v-spacer>
        <v-checkbox
          v-if="isAdmin"
          label="MerchantApp Üyelik Talepleri"
          @change="setOnlyWaitingApprovalFilter()"
        ></v-checkbox>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Ara"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="allReaderAppUsers"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100],
          disablePagination: true,
        }"
        :items-per-page="10"
        @update:page="getPageNumber"
        @click:row="routereaderAppUserDetail"
        @update:items-per-page="getItemPerPage"
      >
        <template v-slot:item.role="{ item }">
          {{
            item.role === 'ReaderUserVenueOwner'
              ? 'Mağaza Sahibi'
              : item.role === 'ReaderUser'
              ? 'Barista'
              : ''
          }}
        </template>
        <template v-slot:item.active="{ item }">
          <v-checkbox
            :disabled="!item.companyId"
            v-model="item.active"
            @change="userStatusChange(item)"
            color="#4d48f9"
          ></v-checkbox>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="routereaderAppUserEdit(item)">
            mdi-pencil
          </v-icon>
          <!-- <v-icon small @click="onBoardingDelete(item)">mdi-delete</v-icon> -->
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          v-model="userPageData.pageNumber"
          :color="'#4d48f9'"
          :length="pagination.pagesLength"
          @input="setPageNumber"
        ></v-pagination>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ReaderAppUsers',
  data: () => ({
    search: '',
    userPageData: {
      pageNumber: 1,
      pageSize: 10,
      search: '',
      onlyWaitingApproval: false,
    },
    pagination: {
      totalItems: 20,
      pagesLength: 0,
    },
    headers: [
      // {
      //   text: "Ad",
      //   align: "start",
      //   // sortable: false,
      //   value: "firstName"
      // },
      // { text: "Soyad", value: "lastName" },
      { text: 'Mail adresi', value: 'email', align: 'start' },
      { text: 'Firma', value: 'company' },
      { text: 'Mağaza', value: 'department' },
      { text: 'Rol', value: 'role' },
      { text: 'Aktif/Pasif', value: 'active' },
      { text: 'Detay', value: 'actions', sortable: false },
    ],
    isAdmin: false,
  }),
  computed: mapGetters(['allReaderAppUsers', 'loading']),
  created() {
    this.isAdmin = JSON.parse(localStorage.getItem('userRoles')).includes(
      'PanelUser',
    )
    const page = this.$route.query.page ? this.$route.query.page : 1
    this.userPageData.pageNumber = Number(page)

    this.getReaderAppUsers(this.userPageData).then((response) => {
      this.pagination.totalItems = response.totalCount
      this.pagination.pagesLength = response.totalPages
    })
  },
  methods: {
    ...mapActions(['getReaderAppUsers', 'putUpdateReaderAppUserActive']),
    routereaderAppUserDetail(user) {
      console.log('user', user)
    },
    //Data table item per page changed function
    getItemPerPage(val) {
      this.userPageData.pageSize = val
      this.userPageData.pageNumber = 1
      this.getReaderAppUsers(this.userPageData).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },
    //Data table page number changed function
    getPageNumber(val) {
      this.userPageData.pageNumber = val
      if (val !== 1) {
        this.$router.push({ query: { page: val } })
      }
      this.getReaderAppUsers(this.userPageData)
    },
    setPageNumber(val) {
      if (
        (!this.$route.query.page && val == 1) ||
        this.$route.query.page == val
      )
        return
      this.$router.push({ path: this.$route.fullPath, query: { page: val } })
    },
    getItemPerSearch(val) {
      this.userPageData.pageNumber = 1
      this.userPageData.search = val
      this.getReaderAppUsers(this.userPageData).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },
    //UserStatus
    userStatusChange(user) {
      this.putUpdateReaderAppUserActive({
        id: user.id,
        active: user.active,
      }).then((response) => {
        if (response.processStatus == 'Success') {
          alert('Başarıyla güncellendi.')
        } else {
          alert(response.friendlyMessage.message)
        }
      })
    },
    //UserAdd
    routeReaderAppUserAdd() {
      this.$router.push('readerAppUser')
    },
    //UserDetail
    routereaderAppUserEdit(item) {
      this.$router.push(`readerAppUser/${item.id}`)
    },
    setOnlyWaitingApprovalFilter() {
      this.userPageData.onlyWaitingApproval = !this.userPageData
        .onlyWaitingApproval
      this.userPageData.pageNumber = 1

      this.getReaderAppUsers(this.userPageData).then((response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      })
    },
  },
  watch: {
    search: function (val, oldVal) {
      if (val.length < 2 && oldVal.length < 2) return
      this.getItemPerSearch(val)
    },
    '$route.query.page'(val) {
      const pageNumber = val ? Number(val) : 1
      this.getPageNumber(pageNumber)
    },
  },
}
</script>

<style>
.v-data-footer__icons-before {
  display: none;
}
.v-data-footer__icons-after {
  display: none;
}
</style>
